import { Box, CircularProgress, Typography } from '@mui/material'
import config from 'config'
import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { resetGQLCache } from 'shared/graphql/client'
import { deleteToken, setToken } from 'shared/utils/auth'

export default function Impersonate() {
    const [searchParams] = useSearchParams()
    const [error, setError] = useState<string | null>(null)
    const exchangeStarted = useRef(false)

    useEffect(() => {
        if (exchangeStarted.current) return
        exchangeStarted.current = true

        const code = searchParams.get('code')
        if (!code) {
            setError('No impersonation code provided')
            return
        }

        const exchange = async () => {
            try {
                const response = await fetch(
                    `${config.api.uri}/impersonate/exchange`,
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ code }),
                    }
                )

                if (!response.ok) {
                    const data = await response.json()
                    setError(
                        data.error || 'Failed to exchange impersonation code'
                    )
                    return
                }

                const { token } = await response.json()

                deleteToken()
                resetGQLCache()
                setToken(token)

                window.location.href = '/'
            } catch (_err) {
                setError('Failed to connect to server')
            }
        }

        exchange()
    }, [searchParams])

    if (error) {
        return (
            <Box sx={{ p: 5, textAlign: 'center' }}>
                <Typography variant="h5">Impersonation Failed</Typography>
                <Typography variant="body1" sx={{ mt: 1 }}>
                    {error}
                </Typography>
            </Box>
        )
    }

    return (
        <Box sx={{ p: 5, textAlign: 'center' }}>
            <CircularProgress size={24} sx={{ mb: 2 }} />
            <Typography variant="body1">Authenticating...</Typography>
        </Box>
    )
}
